
import { defineComponent } from 'vue';
import {
  userAvatarColors,
} from '@/store/modules/Constants';
import { TenantHelpers } from '@/utils/tenant-helpers';

export default defineComponent({
  name: 'ShareUserItem',
  components: {},
  props: {
    orderedTenantUsersValue: {
      type: Array,
      default: () => ([]),
    },
    jigOwnerPermissionValue: {
      type: Object,
      default: () => ({}),
    },
    isConfigSelectActiveValue: {
      type: Object,
      default: () => ({}),
    },
    isJigManagableValue: {
      type: Boolean,
      default: false,
    },
    isMultiJigsShareValue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      jigOwnerPermission: this.jigOwnerPermissionValue,
      isConfigSelectActive: this.isConfigSelectActiveValue,
      isJigManagable: this.isJigManagableValue,
      isMultiJigsShare: this.isMultiJigsShareValue,
      orderedTenantUsers: this.orderedTenantUsersValue,
      configList: {
        view: {
          icon: 'Icon_View.svg',
          text: 'Can view',
        },
        edit: {
          icon: 'Icon_Edit.svg',
          text: 'Can edit',
        },
        delete: {
          icon: 'Icon_Bin.svg',
          text: 'Remove access'
        },
      } as any,
      permissionToCURDMap: {
        U: 'edit',
        R: 'view',
      },
    }
  },
  watch: {
    orderedTenantUsersValue(val) {
      this.orderedTenantUsers = val;
    },
    jigOwnerPermissionValue(val) {
      this.jigOwnerPermission = { ...val };
    },
    isConfigSelectActiveValue(val) {
      this.isConfigSelectActive = { ...val };
    },
    isJigManagableValue(val) {
      this.isJigManagable = val;
    },
    isMultiJigsShareValue(val) {
      this.isMultiJigsShare = val;
    },
  },
  methods: {
    userAvatarColor(index: number) {
      return userAvatarColors[index % 4];
    },
    userEmail(user: any) {
      return `${user.email}${user.roles.includes(TenantHelpers.RoleGuestViewer1) ? ' (Guest)' : ''}`
    },
    userInitial(name: string) {
      return name.substring(0, 1);
    },
    userConfigList(user: any) {
      const userConfigOptions: any = { ...this.configList };

      if (user.email === this.jigOwnerPermission.AudName || this.isMultiJigsShare) {
        delete userConfigOptions.delete
      }

      if (
        (this.currentEditor === user.email && !this.isMultiJigsShare) ||
        user.roles.includes(TenantHelpers.RoleGuestViewer1)
      ) {
        delete userConfigOptions.edit
      }

      return userConfigOptions
    },
    toggleSelectField(user: any) {
      if (!this.isJigManagable) {
        return;
      }

      this.isConfigSelectActive = {
        [user.Uid]: !this.isConfigSelectActive[user.Uid],
      }
    },
    userJigPermission(user: any) {
      if (user.CRUD && user.CRUD.U) {
        // Can edit
        return this.configList[this.permissionToCURDMap.U].text;
      } else if (user.CRUD && user.CRUD.R) {
        // Can view
        return this.configList[this.permissionToCURDMap.R].text;
      } else {
        return 'Give access';
      }
    },
    onUpdateUserPermission(user: any, permission: string|any, toggleSelect: boolean = true) {
      if (!this.isJigManagable) {
        return;
      }

      if (toggleSelect) {
        this.toggleSelectField(user);
      }

      this.$emit('on-update-user-permission', { user, permission });
    }
  },
})
